import request from '@aned/request';


/**
 * 车辆押车监控列表
 * @param {*} params 
 * @returns 
 */
export async function selectPage(params) {
  return request('/api/escort/vehicle/selectPage', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}
/**
 * 车辆押车监控导出
 * @param {*} params 
 * @returns 
 */
export async function vehicleExport(params) {
  return request('/api/escort/vehicle/export', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}